const backInStockSubscription = (email, variantId) => {
    const payload = {
        "data": {
            "type": "back-in-stock-subscription",
            "attributes": {
                "profile": {
                    "data": {
                        "type": "profile",
                        "attributes": {
                            "email": email,
                        }
                    }
                },
                "channels": ["EMAIL"],
            },
            "relationships": {
                "variant": {
                    "data": {
                        "type": "catalog-variant",
                        "id": "$shopify:::$default:::"+variantId
                    }
                }
            }
        }
    }

    const requestOptions = {
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
            "revision": "2024-06-15"
        },
        body: JSON.stringify(payload),
    };

    return fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=WhGD7f",requestOptions);
};
const NotifyMeModal = {
    data() {
        return {
            email: '',
            error: null,
        }
    },
    emits: ['submitNotify','close'],
    props: {
        show: Boolean,
        loading: Boolean,
        submitted: Boolean,
        item: Number
    },
    methods: {
        onAfterLeave(el) {
            document.body.classList.remove('overflow-hidden');
        },
        onSubmit() {
            this.error = null;
            if(!this.email) {
                this.error = 'Email is required';
                return false;
            }
            this.$emit('submitNotify', this.email, this.item);
        }
    },
    template: `
    <Transition name="modal" @after-leave="onAfterLeave">
      <div v-if="item && show" class="modal-mask notify-modal">
        <div class="modal-wrapper" @click="$emit('close')">
          <div class="modal-container light--scrollbar" @click.stop="">
            <div class="modal-body">
              <div class="h2">Email me when available</div>
              <p>Get notified via email when this product is back in stock.</p>
              <div class="form-success" v-if="submitted">Thanks! We will send you an email once the product is available.</div>
              <form method="post" action="/" @submit.prevent="onSubmit" v-else>
                <div class="field field--with-error">
                  <input type="email" class="field__input" placeholder="Enter your email address" v-model="email" required>
                  <label class="field__label">Enter your email address</label>
                  <button type="submit" class="newsletter-form__button field__button" name="commit" aria-label="Subscribe">
                    <svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></path></svg>
                  </button>
                </div>
              </form>
            </div>
            <button class="btn-close modal-close-button" @click="$emit('close')"><span class="aria-description--hidden">Close</span></button>
          </div>
        </div>
      </div>
    </Transition>`
}
const ehPlugin = {
    install(app, options) {
        app.config.globalProperties.isEmpty = (o) => {
            return Object.keys(o).length === 0;
        }
        // Pass knownCountry to skip the browsing-context fetch (used for the first paint).
        app.config.globalProperties.updateLocations = (products, knownCountry) => {
            return (knownCountry ? Promise.resolve(knownCountry) : customerCountry())
                .then((country) => {
                    country = country === 'CA' ? country : 'US';
                    console.log('country',country);
                    products.forEach((product) => {
                        let productFound = false;
                        const productAvailable = product.available;
                        product.available = false;
                        product.variants.forEach((variant) => {
                            let variantFound = false;
                            const variantAvailable = variant.available;
                            variant.available = false;
                            if(variant.inventory.length === 0) {
                                productFound = true;
                                variantFound = true;
                                product.available = productAvailable;
                                variant.available = variantAvailable;
                            } else {
                                variant.inventory.forEach((inv) => {
                                    if(window.evanhealy_settings.locations[inv['location_id']] === country) {
                                        productFound = true;
                                        variantFound = true;
                                        if(inv['available'] > 0) {
                                            variant.available = true;
                                            product.available = true;
                                        }
                                    }
                                })
                            }
                            if(!variantFound) {
                                variant.found = false;
                            }
                        })
                        if(!productFound) {
                            product.found = false;
                        }
                    })
                });
        }
    }
}
